var AllowedUserActionItem = /* @__PURE__ */ ((AllowedUserActionItem2) => {
  AllowedUserActionItem2["TOGGLE"] = "TOGGLE";
  AllowedUserActionItem2["DELETE"] = "DELETE";
  AllowedUserActionItem2["CHANGE_QUANTITY"] = "CHANGE_QUANTITY";
  AllowedUserActionItem2["REQUEST_ON_DEMAND_DISCOUNT"] = "REQUEST_ON_DEMAND_DISCOUNT";
  AllowedUserActionItem2["REQUEST_CONSULTATION_FEE"] = "REQUEST_CONSULTATION_FEE";
  AllowedUserActionItem2["OPEN_PRODUCT_DETAIL"] = "OPEN_PRODUCT_DETAIL";
  return AllowedUserActionItem2;
})(AllowedUserActionItem || {});
var UserActionType = /* @__PURE__ */ ((UserActionType2) => {
  UserActionType2["REQUEST_ON_DEMAND_DISCOUNT"] = "REQUEST_ON_DEMAND_DISCOUNT";
  UserActionType2["REQUEST_CONSULTATION_FEE"] = "REQUEST_CONSULTATION_FEE";
  UserActionType2["USE_DEFERRED_PAYMENT"] = "USE_DEFERRED_PAYMENT";
  UserActionType2["USE_DEPOSIT"] = "USE_DEPOSIT";
  UserActionType2["ADD_CONSULTANT"] = "ADD_CONSULTANT";
  UserActionType2["REQUEST_NEW_SKU"] = "REQUEST_NEW_SKU";
  UserActionType2["CREATE_QUOTATION"] = "CREATE_QUOTATION";
  return UserActionType2;
})(UserActionType || {});
var CartDeliveryType = /* @__PURE__ */ ((CartDeliveryType2) => {
  CartDeliveryType2["DELIVERY_TYPE_UNSPECIFIED"] = "DELIVERY_TYPE_UNSPECIFIED";
  CartDeliveryType2["DELIVERY_TYPE_AT_HOME"] = "DELIVERY_TYPE_AT_HOME";
  CartDeliveryType2["DELIVERY_TYPE_PICKUP"] = "DELIVERY_TYPE_PICKUP";
  CartDeliveryType2["DELIVERY_TYPE_HANDOVER"] = "DELIVERY_TYPE_HANDOVER";
  return CartDeliveryType2;
})(CartDeliveryType || {});
var CheckoutAllowedUserActions = /* @__PURE__ */ ((CheckoutAllowedUserActions2) => {
  CheckoutAllowedUserActions2["PAYMENT"] = "PAYMENT";
  CheckoutAllowedUserActions2["FINISH"] = "FINISH";
  CheckoutAllowedUserActions2["ORDER_LIST"] = "ORDER_LIST";
  CheckoutAllowedUserActions2["QUOTATION_POPUP"] = "QUOTATION_POPUP";
  return CheckoutAllowedUserActions2;
})(CheckoutAllowedUserActions || {});
var DeliveryTimeSlotType = /* @__PURE__ */ ((DeliveryTimeSlotType2) => {
  DeliveryTimeSlotType2["REQUIRED"] = "REQUIRED";
  DeliveryTimeSlotType2["OPTIONAL"] = "OPTIONAL";
  DeliveryTimeSlotType2["NONE"] = "NONE";
  return DeliveryTimeSlotType2;
})(DeliveryTimeSlotType || {});

export { AllowedUserActionItem, CartDeliveryType, CheckoutAllowedUserActions, DeliveryTimeSlotType, UserActionType };
